import axios from "axios";
import { reviews } from "./static";

const API_BLOB_STORAGE_ENDPOINT =
  process.env.REACT_APP_BLOB_STORAGE_ASSETS_DOMAIN;
const API_QA_INTEREST_ENDPOINT =
  process.env.REACT_APP_SKIPTI_INTEREST_API_DOMAIN;

export const getOrganizationInfoByName = async (organizationName) => {
  const orgData = await getOrganizationInfo();
  return orgData.isError ? orgData : orgData[organizationName];
};

export const getOrganizationInfo = async () => {
  try {
    const res = await axios.get(`${API_BLOB_STORAGE_ENDPOINT}/partners.json`);

    return res.data;
  } catch (e) {
    return {
      isError: true,
      error: e,
    };
  }
};

export const fetchZipInfo = async (zip, productId) => {
  try {
    const res = await axios.get(
      `${API_QA_INTEREST_ENDPOINT}/api/v1/verify/serviceable-product/${zip}?productId=${productId}`
    );

    return res.data;
  } catch (e) {
    return {
      isError: true,
      error: e,
    };
  }
};

export const fetchZipInfoByCatGroup = async (zip, externalId, client) => {
  try {
    const res = await axios.get(
      `${API_QA_INTEREST_ENDPOINT}/api/v1/verify/serviceable-extid/${zip}`,
      {
        params: {
          extId: externalId,
          orgname: client || "homedepot",
        },
      }
    );
    window.analytics.track("Register Interest - Sent Zip", {
      url: window.location.href,
      referrer: document.referrer,
      extId: externalId,
      client: client,
      zip: zip,
      response: res.data,
    });
    return res.data;
  } catch (e) {
    return {
      isError: true,
      error: e,
    };
  }
};

// @todo: this method uses QA API
export const sendDetails = async (details) => {
  try {
    const res = await axios.post(
      `${API_QA_INTEREST_ENDPOINT}/api/v1/noninventoried/reg`,
      {
        zipPostal: details.zipPostal,
        email: details.email,
        externalProductId: details.externalProductId,
        organizationId: details.organizationId,
      }
    );

    return res.data;
  } catch (e) {
    return {
      isError: true,
      error: e,
    };
  }
};

/**
 * Add email on the interest list
 *   email: string;
 *   zipPostal: string;
 *   ipAddress: string;
 *   organizationId: string;
 * }} requestBody
 * @return {Promise<{isOk: boolean}>}
 */
export const addEmailInInterestList = async (requestBody) => {
  try {
    const res = await axios.post(
      `${API_QA_INTEREST_ENDPOINT}/api/v1/reg`,
      requestBody
    );

    window.analytics.track("Register Interest - Sent Zip", {
      url: window.location.href,
      referrer: document.referrer,
      email: requestBody?.email,
      zip: requestBody?.manualZip,
      // ipAddress: null,
      organizationId: requestBody?.organizationId,
      productId: requestBody?.productId,
      response: res.data,
    });

    return { isOk: res.status === 200 };
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const getReviews = async () => {
  return reviews;
};
